<template>
    <div class="pendencias-table-wrapper">
        <div class="table-header mb-2 flex align-items-center">
            <h4 class="m-0 text-orange-500 font-bold">Pendências</h4>
        </div>
        
        <DataTable 
            :value="lista" 
            :loading="loading" 
            size="small" 
            stripedRows 
            scrollable 
            scrollHeight="300px"
            class="dark-theme-table"
        >
            <Column style="width: 100px" field="id" header="#" sortable></Column>
            <Column field="descricao" header="Descrição" sortable></Column>
            <Column field="id_primario" header="ID Primário" sortable></Column>
            <Column field="id_secundario" header="ID Secundário" sortable></Column>
            <Column field="etapa" header="Etapa" sortable></Column>
            <Column field="created_at" header="Data/Hora" sortable>
                <template #body="{ data }">
                    {{ dateFormat(data.created_at) }}
                    <span v-if="!data.resolvido" class="font-italic text-gray-400">
                        ({{ data.dias }} dias)
                    </span>
                </template>
            </Column>
            <Column style="width: 150px" bodyClass="flex justify-content-end gap-1">
                <template #body="{ data }">
                    <Button icon="pi pi-file-check" v-tooltip.top="'Contrato'" 
                        class="p-button-rounded p-button-text p-button-help p-0 w-2rem h-2rem"
                        @click="$emit('open-contrato', data)" />
                    <Button icon="pi pi-pen-to-square" v-tooltip.top="'Atualizar'" 
                        class="p-button-rounded p-button-text p-button-info p-0 w-2rem h-2rem"
                        @click="$emit('open-pendencia', data)" />
                    <Button icon="pi pi-trash" v-tooltip.top="'Remover'" 
                        class="p-button-rounded p-button-text p-button-danger p-0 w-2rem h-2rem"
                        @click="$emit('remove-pendencia', data)" />
                </template>
            </Column>

            <template #empty>
                <div class="text-center text-gray-500 py-3">
                    Nenhum registro encontrado
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Moment from 'moment';

export default {
    name: 'PendenciasTable',
    components: {
        DataTable,
        Column,
        Button
    },
    props: {
        lista: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    emits: ['open-contrato', 'open-pendencia', 'remove-pendencia'],
    methods: {
        dateFormat(value) {
            if (!value) return '';
            return Moment.utc(value).local().format("DD/MM/YYYY HH:mm");
        }
    }
}
</script>

<style scoped>
.pendencias-table-wrapper {
    background-color: #1a1a1a; /* Fundo mais escuro como no mockup */
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.table-header h4 {
    font-size: 1.1rem;
}

/* Customizações do PrimeVue DataTable para modo escuro */
:deep(.dark-theme-table .p-datatable-header) {
    background: transparent;
    border: none;
}

:deep(.dark-theme-table .p-datatable-thead > tr > th) {
    background: #141414; /* Preto acinzentado */
    color: #e2e8f0;
    border-bottom: 1px solid #334155;
    border-top: none;
    border-left: none;
    border-right: none;
    font-size: 0.85rem;
    font-weight: 600;
}

:deep(.dark-theme-table .p-datatable-tbody > tr) {
    background: #1a1a1a;
    color: #cbd5e1;
    font-size: 0.85rem;
    transition: background-color 0.2s;
}

:deep(.dark-theme-table .p-datatable-tbody > tr:hover) {
    background: #334155 !important;
}

:deep(.dark-theme-table.p-datatable-striped .p-datatable-tbody > tr.p-row-odd) {
    background: #0d0d0d;
}

:deep(.dark-theme-table .p-datatable-tbody > tr > td) {
    border-bottom: 1px solid #334155;
    border-left: none;
    border-right: none;
}
</style>
